var kind = require("enyo/kind");

require("app/ui/Alert.less");

module.exports = kind(/** @lends  app.ui.Alert.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Alert",

    /**
     * @private
     */
    classes: "app-ui-alert",

    /**
     * The theme to use for this button.
     *
     * @type  {?string}
     * @public
     */
    theme: null,

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.themeChanged();
        };
    }),

    /**
     * Set theme classes based on current theme.
     *
     * @param  {string}  previousTheme  The previous theme
     * @private
     */
    themeChanged: function(previousTheme) {
        var currentTheme = this.get("theme"),
            baseClass    = "app-ui-alert";

        if (previousTheme && previousTheme !== currentTheme) {
            this.removeClass(baseClass + "--" + previousTheme);
        }

        if (currentTheme && currentTheme !== previousTheme) {
            this.addClass(baseClass + "--" + currentTheme);
        }
    }

});
